import { ApiService } from 'services';

/* eslint-disable-next-line */
export function redirectToApi(path) {
  const url = ApiService.getApiUrl();

  if (url && path) {
    window.location = url + path;
  }
}
